import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useInterruptSpitTest = (mailingSplitTestId: string | undefined) => {
  const { fetcher } = useFetch({ method: RequestMethodsEnum.post })

  return () =>
    mailingSplitTestId &&
    fetcher(`/api/dashboard/mailing-service/split-test/${mailingSplitTestId}/interrupt`)
}
